/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContentMasterBulkReviewLanguageView } from './ContentMasterBulkReviewLanguageView';
export type ContentMasterBulkReviewItemView = {
    /**
     * S2G content_master_product UUID (use this for /bulk/apply and /products/{id}/mark-for-edit)
     */
    contentMasterProductId?: string;
    /**
     * Wawi article id (kArtikel)
     */
    wawiArtikelId?: number;
    /**
     * Article number (cArtNr)
     */
    sku?: string | null;
    /**
     * GTIN / barcode (cBarcode)
     */
    gtin?: string | null;
    /**
     * HAN (cHAN)
     */
    han?: string | null;
    /**
     * Cached product title used as the card heading
     */
    titleCache?: string | null;
    /**
     * Main image URL (same shape as in /products list view)
     */
    mainImageUrl?: string | null;
    /**
     * Local Content Master status
     */
    processingStatus?: ContentMasterBulkReviewItemView.processingStatus;
    /**
     * Last bulk-task failure reason (only set when status is `bulk_generate_failed` or `bulk_apply_failed`).
     */
    bulkErrorMessage?: string | null;
    /**
     * Operation of the last bulk submit (from the `bulk_config` snapshot) — tells a TRANSLATE task apart from a generate one (both reuse the `bulk_generate_*` statuses).
     */
    bulkOperation?: ContentMasterBulkReviewItemView.bulkOperation | null;
    /**
     * Drafts grouped by storage language code (lowercase ISO 639-1 from Wawi when set, else kSprache as string). Each entry contains the per-language `fields[]` diff. Empty object when the product has no drafts in any language.
     */
    languages?: Record<string, ContentMasterBulkReviewLanguageView>;
};
export namespace ContentMasterBulkReviewItemView {
    /**
     * Local Content Master status
     */
    export enum processingStatus {
        NEW = 'new',
        IN_PROGRESS = 'in_progress',
        DONE = 'done',
        BULK_GENERATE_QUEUED = 'bulk_generate_queued',
        BULK_GENERATE_IN_PROGRESS = 'bulk_generate_in_progress',
        BULK_GENERATE_DONE = 'bulk_generate_done',
        BULK_GENERATE_FAILED = 'bulk_generate_failed',
        BULK_APPLY_QUEUED = 'bulk_apply_queued',
        BULK_APPLY_IN_PROGRESS = 'bulk_apply_in_progress',
        BULK_APPLY_FAILED = 'bulk_apply_failed',
        LISTING_GENERATE_QUEUED = 'listing_generate_queued',
        LISTING_GENERATE_IN_PROGRESS = 'listing_generate_in_progress',
        LISTING_GENERATE_DONE = 'listing_generate_done',
        LISTING_GENERATE_FAILED = 'listing_generate_failed',
    }
    /**
     * Operation of the last bulk submit (from the `bulk_config` snapshot) — tells a TRANSLATE task apart from a generate one (both reuse the `bulk_generate_*` statuses).
     */
    export enum bulkOperation {
        GENERATE_ALL_FIELDS = 'generate_all_fields',
        TRANSLATE_ALL_FIELDS = 'translate_all_fields',
        APPLY_TO_WAWI = 'apply_to_wawi',
        LISTING_GENERATE_FIELDS = 'listing_generate_fields',
        LISTING_APPLY_TO_WAWI = 'listing_apply_to_wawi',
    }
}

